module.exports = __webpack_public_path__ + "img/overallSolutionDesign.9b0423fd.svg";